// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Platform_SiteUnitsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** ResponseContract for GET /platform/v1/site_units — the resource list (ADR-0019). */
import type { Platform_SiteUnitRow } from './Platform_SiteUnitRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Platform_SiteUnitsResponseDados {
items: Platform_SiteUnitRow[]
}

export type Platform_SiteUnitsResponse = ApiResponse<Platform_SiteUnitsResponseDados>;

registerResponseContract('Platform_SiteUnitsResponse', {
  items: {
    type: 'array',
    required: true,
    items: {
      id:                 { type: 'number',  required: true },
      slug:               { type: 'string',  required: true },
      name:               { type: 'string',  required: true },
      franchise_id:       { type: 'number',  required: false },
      status:             { type: 'string',  required: true },
      country:            { type: 'string',  required: false },
      state:              { type: 'string',  required: false },
      city:               { type: 'string',  required: false },
      instagram_username: { type: 'string',  required: false },
    },
  },
})
